import $ from 'jquery';
const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls } = wp.blockEditor;
const { Button, PanelBody, SelectControl, Icon } = wp.components;
const { Fragment, useEffect } = wp.element;
const { __ } = wp.i18n;
import { accordion } from '../../../resources/scripts/module/accordion';

const BlockEdit = ({ attributes, setAttributes }) => {
  const {
    items,
    sectionTitle,
    sectionClass,
    cornerPositionClass,
    cornerBackgroundClass,
  } = attributes;

  useEffect(() => {
    accordion();
  }, [items]);

  const addItem = () => {
    const newItems = [
      ...items,
      {
        question: 'New Question',
        answer: 'New Answer',
      },
    ];
    setAttributes({ items: newItems });
  };

  const removeItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setAttributes({ items: newItems });
  };

  const updateItem = (index, updates) => {
    const newItems = items.map((item, i) =>
      i === index ? { ...item, ...updates } : item
    );
    setAttributes({ items: newItems });
  };

  const onChangeSectionClass = (newClass) => {
    setAttributes({ sectionClass: newClass });
  };

  const onChangeCornerPositionClass = (newClass) => {
    setAttributes({ cornerPositionClass: newClass });
  };

  const onChangeCornerBackgroundClass = (newClass) => {
    setAttributes({ cornerBackgroundClass: newClass });
  };

  return (
    <Fragment>
      <InspectorControls>
        <PanelBody title={__('FAQ Settings')}>
          <Button isPrimary onClick={addItem}>
            <Icon icon="insert" /> {__('Add Item')}
          </Button>
        </PanelBody>
      </InspectorControls>
      <div className="faq-section-wrapper faq-section-wrapper-inner">
        <div className="content-container">
          <div className="content-wrapper">
            <RichText
              tagName="h2"
              value={sectionTitle}
              onChange={(title) => setAttributes({ sectionTitle: title })}
              placeholder={__('Frequently asked questions')}
            />
          </div>
          <div className="accordion-wrapper">
            {items.map((item, index) => (
              <div className="accordion-item" key={index}>
                <div className="accordion-item-header">
                  <RichText
                    tagName="span"
                    value={item.question}
                    onChange={(question) => updateItem(index, { question })}
                    placeholder={__('Question')}
                  />
                </div>
                <div className="accordion-item-content">
                  <div className="accordion-item-content-wrapper">
                    <RichText
                      tagName="p"
                      value={item.answer}
                      onChange={(answer) => updateItem(index, { answer })}
                      placeholder={__('Answer')}
                    />
                  </div>
                </div>
                <Button isSmall isDestructive onClick={() => removeItem(index)}>
                  <Icon icon="trash" /> {__('Remove Item')}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

registerBlockType('pg/faq-inner-section', {
  title: 'PG FAQ Inner Section',
  icon: 'editor-help',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    items: {
      type: 'array',
      default: [
        {
          question: 'Are the courses free?',
          answer:
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolore quibusdam reprehenderit mollitia soluta voluptate sapiente, sed enim consequuntur nihil omnis magnam voluptas sequi aperiam ab assumenda minus cupiditate. Fugit, adipisci?',
        },
        {
          question: 'Can I get a certificate?',
          answer:
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolore quibusdam reprehenderit mollitia soluta voluptate sapiente, sed enim consequuntur nihil omnis magnam voluptas sequi aperiam ab assumenda minus cupiditate. Fugit, adipisci?',
        },
        {
          question: 'Is there instructor led courses?',
          answer:
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolore quibusdam reprehenderit mollitia soluta voluptate sapiente, sed enim consequuntur nihil omnis magnam voluptas sequi aperiam ab assumenda minus cupiditate. Fugit, adipisci?',
        },
      ],
    },
    sectionTitle: {
      type: 'string',
      source: 'html',
      selector: 'h2',
    },
  },
  edit: BlockEdit,
  save: ({ attributes }) => {
    const { items, sectionTitle } = attributes;

    return (
      <div className="faq-section-wrapper faq-section-wrapper-inner">
        <div className="content-container">
          <div className="content-wrapper">
            <RichText.Content tagName="h2" value={sectionTitle} />
          </div>
          <div className="accordion-wrapper">
            {items.map((item, index) => (
              <div className="accordion-item" key={index}>
                <div className="accordion-item-header">
                  <RichText.Content tagName="span" value={item.question} />
                </div>
                <div className="accordion-item-content">
                  <div className="accordion-item-content-wrapper">
                    <RichText.Content tagName="p" value={item.answer} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  },
});
